import React ,{useEffect} from 'react';
import * as selectors from '../selectors'
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import TickPositive from '../../webcommon/common/Icons/Tick-Positive.svg'
import CrossNegative from '../../webcommon/common/Icons/Cross-Negative.svg'
import FilterHeader from '../../webcommon/header/filterheader/FilterHeader';
import {StatusPageConnected, RefreshData} from '../actions'
import GridHeader from '../../common/gridheader/GridHeader';
import Grid from '../../webcommon/grid/Grid';
import styles from './statusPage.module.scss'
import {statusPageColumns} from '../constants'

export const StatusPage = (props) => {
    const { StatusPageConnected } = props;
    useEffect(() => {
        StatusPageConnected();
    }, [StatusPageConnected]);

    let success = props.statusSql;

    return ( 
        <div className={ styles.idGrid }>
        
        <GridHeader
            title="SQL Server Status"
            lastUpdated={ props.lastUpdated }
            refreshControlsActive
            refreshData={ props.RefreshData }
        >{success && <img
            alt="Success"
            src={ TickPositive }
            className={ styles.svg }
        />}
        {!success && <img
            alt="Failure"
            src={ CrossNegative }
            className={ styles.svg }
        />}
        </GridHeader>
        <div className={ styles.gridContainer }>
            <Grid
                columns={ statusPageColumns }
                defaultColumnSpacing={ 2 }
                rows={ props.rowsForStatusPage }
                loading={ props.loading }                    
            />
            
        </div>
    </div>); 
}

StatusPage.propTypes = {    
};

StatusPage.defaultProps = {
    styles: styles,    

};

const mapDispatchToProps = {
    StatusPageConnected,
    RefreshData
};

const mapStateToProps = state => ( 
    {
        rowsForStatusPage: selectors.getRowsStatusPage(state),
        statusSql: state.settings.statusSql,
        loading: state.settings.loadingStatusPage,
        lastUpdated: selectors.getLastUpdatedStatus(state)
    }
)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StatusPage));
